// tslint:disable:max-line-length

import React from 'react';

export const DatatypeLocation = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path
        d="M5 0c-2.761 0-5 2.239-5 5 0 3.75 5 11 5 11s5-7.25 5-11c0-2.761-2.239-5-5-5zm0 3c1.105 0 2 .895 2 2s-.895 2-2 2-2-.895-2-2 .895-2 2-2z"
        transform="translate(3)"
      />
    </svg>
  );
};
